import { StyledDate, StyledDescription } from './style';

// Shared Components
import { Dates } from '@components/Dates';
import { FC } from 'react';
import { CardHeader, CardSpacer, MediaCardImage } from '../BaseCard/BaseCard';
import { CardContentWrapper, CardWrapper } from '../style';

interface MediaCardProps {
  publicationLogo?: string;
  alt_text?: string;
  title?: string;
  url?: string;
  publicationDate?: string;
  description?: string;
  locale: string;
}

export const MediaCard: FC<MediaCardProps> = ({
  publicationLogo,
  alt_text,
  title,
  url,
  publicationDate,
  description,
  locale,
}) => {
  return (
    <CardWrapper>
      {publicationLogo && <MediaCardImage image={publicationLogo} alt_text={alt_text} url={url} />}

      {title && <CardHeader header={title} url={url} target />}

      <CardSpacer />

      <CardContentWrapper>
        <StyledDescription>{description}</StyledDescription>
        {publicationDate && (
          <StyledDate>
            <Dates startDate={publicationDate} locale={locale} />
          </StyledDate>
        )}
      </CardContentWrapper>
    </CardWrapper>
  );
};

export default MediaCard;
